// extracted by mini-css-extract-plugin
module.exports = {"buttonsArea":"widget-space--buttonsArea--1Blro","fileInput":"widget-space--fileInput--XZ2iz"};